module.exports = __webpack_public_path__ + "static/media/peoples.b03e9d69.svg";